import React from "react";
import { X } from "react-feather";
import Modal from "react-modal";
import ModalContent from "../../../common/Modal/ModalContent";

import moment from "moment";
import { ControlledInput } from "../../../common/Input/Input";

export default function UserProfileSupportedDataModal(props) {
  const MODAL_FIELDS = {
    sSupportedStatus: "BUSINESS SUPPORTED STATUS",
    dtSupported: "SUPPORTED DATE",
    dtBenefited: "BENEFITED DATE",
    bBenefitedFlag: "BENEFITED FLAG",
    sBenefitedDescription: "BENEFITED DESCRIPTION",
    sBenefitedFacilitator: "BENEFITED FACILITATOR",
    dtImpacted: "IMPACTED DATE",
    sImpactedDescription: "IMPACTED DESCRIPTION",
    sImpactedFacilitator: "IMPACTED FACILITATOR",
  };
  function dynamicSort(property) {
    var sortOrder = 1;

    return function (a, b) {
      if (sortOrder == -1) {
        return b[property]["label"].localeCompare(a[property]["label"]);
      } else {
        return a[property]["label"].localeCompare(b[property]["label"]);
      }
    };
  }

  return (
    <Modal
      isOpen={props.isOpen}
      onRequestClose={props.toggleModal}
      ariaHideApp={false}
    >
      <ModalContent className="user-profile-modal">
        <div className="p-2 modals-headers-bar">
          <span>Impact Metrics Data</span>
          <button
            type="button"
            className="close"
            aria-label="Close"
            onClick={props.toggleModal}
          >
            <X style={{ pointerEvents: "none" }} color="white" />
          </button>
        </div>
        <div className="modal-body" style={{ height: "570px" }}>
          {props.additionalData&&props.additionalData.impacted_data? (
            <>
              <div>
                <div className="row panel">
                {props.additionalData.impacted_data[0]?
                (
                  <>
                    <div className="col-6">
                      <ControlledInput
                        key={"ResourceName"}
                        name={"ResourceName"}
                        label={"Resource Name"}
                        value={
                          props.additionalData.impacted_data[0]["ResourceName"]
                        }
                        className="disabled"
                      />
                    </div>
                    <div className="col-6">
                      <ControlledInput
                        key={"UserType"}
                        name={"UserType"}
                        label={"User Type"}
                        value={
                          props.additionalData.impacted_data[0]["UserType"]
                        }
                        className="disabled"
                      />
                    </div>
                    <div className="col-6">
                      <ControlledInput
                        key={"Source"}
                        name={"Source"}
                        label={"Source"}
                        value={
                          props.additionalData.impacted_data[0]["Source"]
                        }
                        className="disabled"
                      />
                    </div>
                    <div className="col-6">
                      <ControlledInput
                        key={"dtCreated"}
                        name={"dtCreated"}
                        label={"Created Date"}
                        value={moment(
                          moment
                            .utc(
                              props.additionalData.impacted_data[0]["dtCreated"]
                            )
                            .toDate()
                        )
                          .local()
                          .format("MMMM Do YYYY, h:mm:ss a")}
                        className="disabled"
                      />
                    </div>
                    <div className="col-6">
                      <ControlledInput
                        key={"Medium"}
                        name={"Medium"}
                        label={"Medium"}
                        value={
                          props.additionalData.impacted_data[0]["Medium"]
                        }
                        className="disabled"
                      />
                    </div>
                    <div className="col-6">
                      <ControlledInput
                        key={"EntryPoint"}
                        name={"EntryPoint"}
                        label={"Entry Point"}
                        value={
                          props.additionalData.impacted_data[0]["EntryPoint"]
                        }
                        className="disabled"
                      />
                    </div>
                  </>
                ):("")}
                </div>                
                  {props.additionalData.impacted_data[1]?
                  (
                    <>
                    <div className="row panel">
                      <div className="col-6">
                        <ControlledInput
                          key={"ResourceName"}
                          name={"ResourceName"}
                          label={"Resource Name"}
                          value={
                            props.additionalData.impacted_data[1]["ResourceName"]
                          }
                          className="disabled"
                        />
                      </div>
                      <div className="col-6">
                        <ControlledInput
                          key={"UserType"}
                          name={"UserType"}
                          label={"User Type"}
                          value={
                            props.additionalData.impacted_data[1]["UserType"]
                          }
                          className="disabled"
                        />
                      </div>
                      <div className="col-6">
                        <ControlledInput
                          key={"Source"}
                          name={"Source"}
                          label={"Source"}
                          value={
                            props.additionalData.impacted_data[1]["Source"]
                          }
                          className="disabled"
                        />
                      </div>
                      <div className="col-6">
                        <ControlledInput
                          key={"dtCreated"}
                          name={"dtCreated"}
                          label={"Created Date"}
                          value={moment(
                            moment
                              .utc(
                                props.additionalData.impacted_data[1]["dtCreated"]
                              )
                              .toDate()
                          )
                            .local()
                            .format("MMMM Do YYYY, h:mm:ss a")}
                          className="disabled"
                        />
                      </div>
                      <div className="col-6">
                        <ControlledInput
                          key={"Medium"}
                          name={"Medium"}
                          label={"Medium"}
                          value={
                            props.additionalData.impacted_data[1]["Medium"]
                          }
                          className="disabled"
                        />
                      </div>
                      <div className="col-6">
                        <ControlledInput
                          key={"EntryPoint"}
                          name={"EntryPoint"}
                          label={"Entry Point"}
                          value={
                            props.additionalData.impacted_data[1]["EntryPoint"]
                          }
                          className="disabled"
                        />
                      </div>
                      </div>
                    </>
                  ):("")}                  
                </div>
              {/*<div>
                <div className="row panel">
                  <div className="col-6">
                    <ControlledInput
                      key={"sSupportedStatus"}
                      name={"sSupportedStatus"}
                      label={MODAL_FIELDS["sSupportedStatus"]}
                      value={
                        props.additionalData.supported_data["sSupportedStatus"]
                      }
                      className="disabled"
                    />
                  </div>
                  <div className="col-6">
                    <ControlledInput
                      key={"dtSupported"}
                      name={"dtSupported"}
                      label={MODAL_FIELDS["dtSupported"]}
                      value={moment(
                        moment
                          .utc(
                            props.additionalData.supported_data["dtSupported"]
                          )
                          .toDate()
                      )
                        .local()
                        .format("MMMM Do YYYY, h:mm:ss a")}
                      className="disabled"
                    />
                  </div>
                </div>

                <div className="row panel">
                  <div className="col-6">
                    <ControlledInput
                      key={"dtBenefited"}
                      name={"dtBenefited"}
                      label={MODAL_FIELDS["dtBenefited"]}
                      value={moment(
                        moment
                          .utc(
                            props.additionalData.supported_data["dtBenefited"]
                          )
                          .toDate()
                      )
                        .local()
                        .format("MMMM Do YYYY, h:mm:ss a")}
                      className="disabled"
                    />
                  </div>
                  <div className="col-6">
                    <ControlledInput
                      key={"bBenefitedFlag"}
                      name={"bBenefitedFlag"}
                      label={MODAL_FIELDS["bBenefitedFlag"]}
                      value={
                        props.additionalData.supported_data["bBenefitedFlag"]
                      }
                      className="disabled"
                    />
                  </div>

                  { // <ControlledInput
              //   key={""}
              //   name={key}
              //   label={MODAL_FIELDS[key]}
              //   value={props.additionalData.supported_data["dtBenefited"]}
              //   className="disabled"
              // />}
                  <div className="col-6">
                    <ControlledInput
                      key={"sBenefitedDescription"}
                      name={"sBenefitedDescription"}
                      label={MODAL_FIELDS["sBenefitedDescription"]}
                      value={
                        props.additionalData.supported_data[
                          "sBenefitedDescription"
                        ]
                      }
                      className="disabled"
                    />
                  </div>
                  <div className="col-6">
                    <ControlledInput
                      key={"sBenefitedFacilitator"}
                      name={"sBenefitedFacilitator"}
                      label={MODAL_FIELDS["sBenefitedFacilitator"]}
                      value={
                        props.additionalData.supported_data[
                          "sBenefitedFacilitator"
                        ]
                      }
                      className="disabled"
                    />
                  </div>
                </div>

                <div className="row panel">
                  <div className="col-6">
                    <ControlledInput
                      key={"dtImpacted"}
                      name={"dtImpacted"}
                      label={MODAL_FIELDS["dtImpacted"]}
                      value={moment(
                        moment
                          .utc(
                            props.additionalData.supported_data["dtImpacted"]
                          )
                          .toDate()
                      )
                        .local()
                        .format("MMMM Do YYYY, h:mm:ss a")}
                      className="disabled"
                    />
                  </div>
                  <div className="col-6">
                    <ControlledInput
                      key={"sImpactedDescription"}
                      name={"sImpactedDescription"}
                      label={MODAL_FIELDS["sImpactedDescription"]}
                      value={
                        props.additionalData.supported_data[
                          "sImpactedDescription"
                        ]
                      }
                      className="disabled"
                    />
                  </div>
                  <div className="col-6">
                    <ControlledInput
                      key={"sImpactedFacilitator"}
                      name={"sImpactedFacilitator"}
                      label={MODAL_FIELDS["sImpactedFacilitator"]}
                      value={
                        props.additionalData.supported_data[
                          "sImpactedFacilitator"
                        ]
                      }
                      className="disabled"
                    />
                  </div>
                  {// <ControlledInput
                //key={key}
                //name={key}
                //label={MODAL_FIELDS[key]}
                //value={props.additionalData.supported_data["dtBenefited"]}
                //className="disabled"
              ///> }
                </div>
                  </div>*/}
            </>
          ) : (
            <span>No data to show</span>
          )}
        </div>
      </ModalContent>
    </Modal>
  );
}
